import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/internal/Observable';
import { environment } from "../../../../environments/environment";

export type HttpListResponseFailure = { status: string, message: string };

const endpoints = {
    getReportsByOrgID: `${environment.apiUrl}/ReportAPI/GetByOrgID`,
    generateReport: `${environment.apiUrl}/ReportAPI/ExecuteReportById`,
    getDashboardURL: `${environment.apiUrl}/bi/dashboard/get-url`
};

@Injectable({
    providedIn: "root"
})
export class ReportService {
    private http: HttpClient = inject(HttpClient);

    getReportsByOrgID(organisationId: string): Observable<HttpListResponseFailure | any> {
        return this.http.post<HttpListResponseFailure | any>(endpoints.getReportsByOrgID, { 'organisation_id': organisationId });
    }

    generateReport(organisationId: string, reportID: string, returnCSV: boolean, parameters: {}): Observable<HttpListResponseFailure | any> {
        let _body = {
            'organisation_id': organisationId,
            'parameters': parameters,
            'report_id': reportID,
            'return_csv': returnCSV
        }
        return this.http.post<HttpListResponseFailure | any>(endpoints.generateReport, _body);
    }

    getDashboardURL(dashboardID: string, darkMode: boolean): Observable<HttpListResponseFailure | any> {
      const body: { [key: string]: unknown } = {
          "id": dashboardID,
          "dark_mode": darkMode
      };
      return this.http.post(endpoints.getDashboardURL, body);
  }
}
